<!-- Item wrapper -->
<div class="calsoft-vertical-navigation-item-wrapper"
     [class.calsoft-vertical-navigation-item-has-subtitle]="!!item.subtitle"
     [ngClass]="item.classes">

    <div class="calsoft-vertical-navigation-item" [guide]="'menu-' + (item.id || item.defaultName)">

        <!-- Icon -->
        <mat-icon class="calsoft-vertical-navigation-item-icon"
                  [ngClass]="item.iconClasses"
                  *ngIf="item.icon"
                  [svgIcon]="item.icon"></mat-icon>

        <!-- Title & Subtitle -->
        <div class="calsoft-vertical-navigation-item-title-wrapper">
            <div class="calsoft-vertical-navigation-item-title">{{item.defaultName | titlecase}}</div>
            <div class="calsoft-vertical-navigation-item-subtitle"
                 *ngIf="item.subtitle">
                {{item.subtitle | titlecase}}
            </div>
        </div>

        <!-- Badge -->
        <div class="calsoft-vertical-navigation-item-badge"
             *ngIf="item.badge">

            <div class="calsoft-vertical-navigation-item-badge-content"
                 [ngClass]="[(item.badge.style != undefined ? 'calsoft-vertical-navigation-item-badge-style-' + item.badge.style : ''),
                             (item.badge.background != undefined && !item.badge.background.startsWith('#') ? item.badge.background : ''),
                             (item.badge.color != undefined && !item.badge.color.startsWith('#') ? item.badge.color : '')]"
                 [ngStyle]="{'background-color': item.badge.background, 'color': item.badge.color}">
                {{item.badge.title | titlecase}}
            </div>

        </div>

    </div>

</div>

<ng-container *ngFor="let item of item.children; trackBy: trackByFn">

    <!-- Skip the hidden items -->
    <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

        <!-- Basic -->
        <calsoft-vertical-navigation-basic-item *ngIf="item.type === 'basic'"
                                            [item]="item"
                                            [name]="name"></calsoft-vertical-navigation-basic-item>

        <!-- Collapsable -->
        <calsoft-vertical-navigation-collapsable-item *ngIf="item.type === 'collapsable'"
                                                  [item]="item"
                                                  [name]="name"
                                                  [autoCollapse]="autoCollapse"></calsoft-vertical-navigation-collapsable-item>

        <!-- Divider -->
        <calsoft-vertical-navigation-divider-item *ngIf="item.type === 'divider'"
                                              [item]="item"
                                              [name]="name"></calsoft-vertical-navigation-divider-item>

        <!-- Group -->
        <calsoft-vertical-navigation-group-item *ngIf="item.type === 'group'"
                                            [item]="item"
                                            [name]="name"></calsoft-vertical-navigation-group-item>

        <!-- Spacer -->
        <calsoft-vertical-navigation-spacer-item *ngIf="item.type === 'spacer'"
                                             [item]="item"
                                             [name]="name"></calsoft-vertical-navigation-spacer-item>

    </ng-container>

</ng-container>
